export default __webpack_public_path__ + "static/media/Ballroll_00128.a9a87e20.png";